const DOCS_BASE_URL = (import.meta.env.VITE_DOCS_BASE_URL || "https://docs.snapcollars.com.au").replace(/\/$/, "")

// Builds the clean-URL proxy link (docs.snapcollars.com.au/documents/<name>) that
// hides the timestamped S3 key. Falls back to the raw cdn_url when no clean
// fileName is available (e.g. a record predates the s3files.file_name join).
export const buildDocumentUrl = (fileName: string | null | undefined, fallbackUrl: string | null | undefined): string | null => {
  if (fileName) {
    return `${DOCS_BASE_URL}/documents/${encodeURIComponent(fileName)}`
  }
  return fallbackUrl ?? null
}
